// Olive Professional design
const OliveProfessionalDesign = {
  id: 'olive-professional',
  name: 'Olive',
  category: 'professional',
  description: 'Earthy olive green tones for a grounded feel',
  colors: {
    primary: "#556B2F",    // Dark Olive Green
    secondary: "#8FBC8F",  // Medium Olive/Khaki (DarkSeaGreen)
    tertiary: "#B2D8B2",   // Light Sage Green
    quaternary: "#E0EEE0", // Very Light Green/Grey
    accent1: "#556B2F",    // Dark Olive Green
    accent2: "#8FBC8F",    // Medium Olive/Khaki
    // Add other accents if needed
    text: "#3A4F3A",       // Dark Olive/Grey Text
    textSecondary: "#6B8E6B", // Medium Grey/Green Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#F0FFF0", // Very Light Green/Grey (Honeydew)
    border: "#ffffff"     // Light Sage Green border
  },
};

export default OliveProfessionalDesign; 